// Safely get initial state from localStorage
const getInitialState = (key) => {
  try {
    const data = localStorage.getItem(key);
    if (data) {
      const parsedData = JSON.parse(data);
      return (Array.isArray(parsedData) && parsedData.length > 0) ? parsedData[0] : 0;
    }
    return 0;
  } catch (error) {
    console.warn(`Failed to parse ${key} from localStorage:`, error);
    return 0;
  }
};

let initialState = getInitialState("upcomingActlistData");

const upcomingActlistData = (state = initialState, action) => {

    switch(action.type){ 
      case "UPCOMING_AUCTION" : return action.parm;
      case "RESET": return initialState;
      default : return state;
  }
}

export default upcomingActlistData